
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/author/[author]",
      function () {
        return require("private-next-pages/articles/author/[author].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/author/[author]"])
      });
    }
  